import AppErrorBoundary from '../AppErrorBoundary';

import MonthViewChart from './MonthViewChart';
import './MonthViewCharts.scss';

type MonthViewBarChartsProps = {
  isReturn: boolean;
};

const MonthViewBarCharts = ({ isReturn }: MonthViewBarChartsProps) => (
  <div className="month-view-charts clearfix">
    {isReturn ? (
      <div>
        <AppErrorBoundary location="month-view-chart-outbound">
          <MonthViewChart direction="outbound" />
        </AppErrorBoundary>

        <hr className="month-view-charts__separator" />

        <AppErrorBoundary location="month-view-chart-inbound">
          <MonthViewChart direction="inbound" />
        </AppErrorBoundary>
      </div>
    ) : (
      <AppErrorBoundary location="month-view-chart-one-way">
        <MonthViewChart direction="outbound" />
      </AppErrorBoundary>
    )}
  </div>
);

export default MonthViewBarCharts;
